/** Routes where lists can be scoped by account (synced via ?account_id=). */
export const ACCOUNT_CONTEXT_PATHS = [
  '/system/users',
  '/system/integrations',
  '/system/sip-credentials',
  '/billing/dashboard',
  '/uc-admin/settings-and-security/music-on-hold',
  '/uc-admin/settings-and-security/captchas',
  '/uc-admin/settings-and-security/blocked-numbers',
  '/uc-admin/settings-and-security/recordings',
  '/uc-admin/call-flow/two-way-toggles',
  '/uc-admin/call-flow/multiway-toggles',
  '/uc-admin/call-flow/api-routers',
  '/uc-admin/call-flow/tag-routers',
  '/uc-admin/call-flow/call-queues',
  '/uc-admin/call-flow/ring-groups',
  '/uc-admin/call-flow/ivr-menus',
  '/uc-admin/call-flow/schedules',
  '/uc-admin/call-flow/vip-callers',
  '/uc-admin/extensions-and-devices/extensions',
  '/uc-admin/extensions-and-devices/phonebooks',
  '/uc-admin/extensions-and-devices/provisioning-devices',
  '/uc-admin/settings-and-security/webhooks',
  '/uc-admin/settings-and-security/star-codes',
  '/uc-admin/call-control-apps/automations',
  '/uc-admin/call-control-apps/call-parking-lots',
  '/uc-admin/call-control-apps/conference-bridges',
  '/uc-admin/call-control-apps/directories',
  '/uc-admin/call-control-apps/forwarders',
  '/uc-admin/call-control-apps/page-groups',
  '/uc-admin/call-control-apps/wakeup-calls',
  '/uc-user/automations',
  '/uc-user/blocked-numbers',
  '/uc-user/phonebooks',
  '/uc-user/call-flow-settings',
  '/uc-user/schedules',
  '/uc-user/faxing',
  '/uc-user/messaging',
  '/reports/administrative/automations',
  '/reports/voice/call-history',
  '/reports/voice/ivr-analysis',
  '/reports/voice/missed-calls',
  '/reports/voice/extension-analysis',
  '/reports/voice/inbound-analysis',
  '/reports/message-logs',
  '/reports/voice/call-queue-analysis',
  '/uc-admin/phone-numbers',
  '/phone-numbers'
] as const

export const ACCOUNT_CONTEXT_QUERY_KEY = 'account_id'

export function isAccountContextPath(path: string): boolean {
  const normalized = path.split('?')[0]?.replace(/\/$/, '') || '/'
  return ACCOUNT_CONTEXT_PATHS.some((p) => normalized === p || normalized.startsWith(`${p}/`))
}
